module.exports = __webpack_public_path__ + "img/selected0-min.e1cfaf06.png";